// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field[data-v-165e43ca], .v-select[data-v-165e43ca] {\n  padding-top: 0px;\n  margin-top: 4px;\n}\n.hidden[data-v-165e43ca] {\n  visibility: hidden;\n}", ""]);
// Exports
module.exports = exports;
